import React, { useState } from "react";
import { useNavigate, useLocation  } from "react-router-dom";

interface LoginProps {
  onLogin: (modules: { id: number; title: string; url: string }[]) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const justSignedUp = location.state?.fromSignup;
  const justResetPassword = location.state?.fromPasswordReset;


  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");


    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (data.success) {
        const { user } = data.data;

        onLogin(user.modules);
        localStorage.setItem("userId", `${user.current_role}`);
        if (user.current_role === 1 || user.current_role === 8) {
          navigate("/admin-dashboard");
        } else {
          navigate("/dashboard");
        }

        localStorage.setItem("token", data.data.token);
        localStorage.setItem("user", JSON.stringify(data.data.user));
      } else {
        if (data.message) {
          setError(data.message);
        } else {
          setError("Invalid email or password.");
        }
      }
    } catch (err) {
      setError("Failed to login. Please try again." + err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <div className="section-2">
      <div className="div-block-14">
        <div className="div-block-15-copy">
          <p className="small-headline">
            {justResetPassword
            ? "Password reset successfully. Please sign in."
            : justSignedUp
            ? "Store created successfully! Please sign in to continue."
            : "Welcome back! Sign in to your account."}
            <strong><br /></strong>
          </p>
          <div className="login-form-wrapper">
            <form id="react-login-form" className={`form ${isLoading ? "form--loading" : ""}`} onSubmit={handleLogin}>
              <label htmlFor="name" className="field-label">Email Address</label>
              <input className="text-field w-input" maxLength={256} name="name" placeholder="" type="email" id="name" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <label htmlFor="email-2" className="field-label">Password<br /></label>
              <input className="text-field w-input" maxLength={256} name="email-2" placeholder="" type="password" id="email-2" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <button type="submit" className="coa-button-copy w-button" disabled={isLoading}>
                {isLoading && <span className="spinner" />}
                Sign in
              </button>
              {error && <p className="form-error-msg">{error}</p>}
              <p className="paragraph-text-sm-copy">
                <a href="/forgot-password" className="link-copy">Forgot password </a><strong><br /></strong>
              </p>
            </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
